import { useQuery } from "@tanstack/react-query";
import { permissionsService } from "@/features/permissions/services/permissionsService";
import { queryKeys } from "@/lib/query-keys";
import type { PermissionMatrixQuery } from "@/types/permission";

export function usePermissionMatrix(query?: PermissionMatrixQuery) {
  return useQuery({
    queryKey: queryKeys.permissions.matrix(query),
    queryFn: () => permissionsService.getMatrix(query),
  });
}

export function useMyPermissions() {
  return useQuery({
    queryKey: queryKeys.permissions.me(),
    queryFn: () => permissionsService.getMyPermissions(),
  });
}

export function useUserPermissions(userId: string, enabled = true) {
  return useQuery({
    queryKey: queryKeys.permissions.user(userId),
    queryFn: () => permissionsService.getUserPermissions(userId),
    enabled: !!userId && enabled,
  });
}
